import { ReactComponent as o } from "./icons/additional.svg.js";
import { ReactComponent as t } from "./icons/alert-error.svg.js";
import { ReactComponent as e } from "./icons/alert-success.svg.js";
import { ReactComponent as r } from "./icons/arrow-down.svg.js";
import { ReactComponent as m } from "./icons/arrow-left.svg.js";
import { ReactComponent as a } from "./icons/arrow-light-down.svg.js";
import { ReactComponent as n } from "./icons/arrow-light-left.svg.js";
import { ReactComponent as p } from "./icons/arrow-light-right.svg.js";
import { ReactComponent as i } from "./icons/arrow-light-up.svg.js";
import { ReactComponent as c } from "./icons/arrow-right.svg.js";
import { ReactComponent as s } from "./icons/arrow-up.svg.js";
import { ReactComponent as g } from "./icons/book.svg.js";
import { ReactComponent as l } from "./icons/calendar.svg.js";
import { ReactComponent as f } from "./icons/checkmark.svg.js";
import { ReactComponent as C } from "./icons/chevron-down.svg.js";
import { ReactComponent as v } from "./icons/chevron-left.svg.js";
import { ReactComponent as S } from "./icons/chevron-right.svg.js";
import { ReactComponent as R } from "./icons/chevron-up.svg.js";
import { ReactComponent as d } from "./icons/circle.svg.js";
import { ReactComponent as h } from "./icons/circle-checkmark.svg.js";
import { ReactComponent as w } from "./icons/circle-close.svg.js";
import { ReactComponent as u } from "./icons/close.svg.js";
import { ReactComponent as k } from "./icons/color-indicator.svg.js";
import { ReactComponent as b } from "./icons/connected.svg.js";
import { ReactComponent as L } from "./icons/copy-link.svg.js";
import { ReactComponent as A } from "./icons/cross.svg.js";
import { ReactComponent as D } from "./icons/default-avatar.svg.js";
import { ReactComponent as M } from "./icons/diagnostics.svg.js";
import { ReactComponent as P } from "./icons/download.svg.js";
import { ReactComponent as y } from "./icons/dropdown.svg.js";
import { ReactComponent as x } from "./icons/dummy.svg.js";
import { ReactComponent as F } from "./icons/email.svg.js";
import { ReactComponent as I } from "./icons/external-link.svg.js";
import { ReactComponent as U } from "./icons/facebook.svg.js";
import { ReactComponent as E } from "./icons/fax.svg.js";
import { ReactComponent as T } from "./icons/file.svg.js";
import { ReactComponent as q } from "./icons/file-download.svg.js";
import { ReactComponent as B } from "./icons/filter.svg.js";
import { ReactComponent as G } from "./icons/globe.svg.js";
import { ReactComponent as O } from "./icons/globe-mobile.svg.js";
import { ReactComponent as W } from "./icons/google-cal.svg.js";
import { ReactComponent as Y } from "./icons/info.svg.js";
import { ReactComponent as j } from "./icons/instagram.svg.js";
import { ReactComponent as z } from "./icons/linkedin.svg.js";
import { ReactComponent as H } from "./icons/list.svg.js";
import { ReactComponent as J } from "./icons/loading.svg.js";
import { ReactComponent as K } from "./icons/location.svg.js";
import { ReactComponent as N } from "./icons/logo.svg.js";
import { ReactComponent as Q } from "./icons/map.svg.js";
import { ReactComponent as V } from "./icons/medicine.svg.js";
import { ReactComponent as X } from "./icons/minus.svg.js";
import { ReactComponent as Z } from "./icons/mobile.svg.js";
import { ReactComponent as _ } from "./icons/mobile-close.svg.js";
import { ReactComponent as $ } from "./icons/mobile-menu.svg.js";
import { ReactComponent as oo } from "./icons/mobile-search.svg.js";
import { ReactComponent as to } from "./icons/molecular-item.svg.js";
import { ReactComponent as eo } from "./icons/outlook.svg.js";
import { ReactComponent as ro } from "./icons/partnership.svg.js";
import { ReactComponent as mo } from "./icons/patient.svg.js";
import { ReactComponent as ao } from "./icons/pause.svg.js";
import { ReactComponent as no } from "./icons/pause-bare.svg.js";
import { ReactComponent as po } from "./icons/people.svg.js";
import { ReactComponent as io } from "./icons/phone.svg.js";
import { ReactComponent as co } from "./icons/play.svg.js";
import { ReactComponent as so } from "./icons/play-bare.svg.js";
import { ReactComponent as go } from "./icons/plus.svg.js";
import { ReactComponent as lo } from "./icons/podcasts.svg.js";
import { ReactComponent as fo } from "./icons/remove.svg.js";
import { ReactComponent as Co } from "./icons/search.svg.js";
import { ReactComponent as vo } from "./icons/search-mobile.svg.js";
import { ReactComponent as So } from "./icons/series.svg.js";
import { ReactComponent as Ro } from "./icons/sort-ascending.svg.js";
import { ReactComponent as ho } from "./icons/sort-descending.svg.js";
import { ReactComponent as wo } from "./icons/stock-down.svg.js";
import { ReactComponent as uo } from "./icons/stock-equal.svg.js";
import { ReactComponent as ko } from "./icons/stock-up.svg.js";
import { ReactComponent as bo } from "./icons/time.svg.js";
import { ReactComponent as Lo } from "./icons/twitter.svg.js";
import { ReactComponent as Ao } from "./icons/upload.svg.js";
import { ReactComponent as Do } from "./icons/warning-triangle.svg.js";
import { ReactComponent as Mo } from "./icons/youtube.svg.js";
const te = {
  additional: o,
  "alert-error": t,
  "alert-success": e,
  "arrow-down": r,
  "arrow-left": m,
  "arrow-light-down": a,
  "arrow-light-left": n,
  "arrow-light-right": p,
  "arrow-light-up": i,
  "arrow-right": c,
  "arrow-up": s,
  book: g,
  calendar: l,
  checkmark: f,
  "chevron-down": C,
  "chevron-left": v,
  "chevron-right": S,
  "chevron-up": R,
  circle: d,
  "circle-checkmark": h,
  "circle-close": w,
  close: u,
  "color-indicator": k,
  connected: b,
  "copy-link": L,
  cross: A,
  "default-avatar": D,
  diagnostics: M,
  download: P,
  dropdown: y,
  dummy: x,
  email: F,
  "external-link": I,
  facebook: U,
  fax: E,
  "file-download": q,
  file: T,
  filter: B,
  "globe-mobile": O,
  globe: G,
  "google-cal": W,
  info: Y,
  instagram: j,
  linkedin: z,
  list: H,
  loading: J,
  location: K,
  logo: N,
  map: Q,
  medicine: V,
  minus: X,
  "mobile-close": _,
  "mobile-menu": $,
  "mobile-search": oo,
  mobile: Z,
  "molecular-item": to,
  outlook: eo,
  partnership: ro,
  "pause-bare": no,
  pause: ao,
  patient: mo,
  people: po,
  phone: io,
  "play-bare": so,
  play: co,
  plus: go,
  podcasts: lo,
  remove: fo,
  "search-mobile": vo,
  search: Co,
  series: So,
  "sort-ascending": Ro,
  "sort-descending": ho,
  "stock-down": wo,
  "stock-equal": uo,
  "stock-up": ko,
  time: bo,
  twitter: Lo,
  upload: Ao,
  "warning-triangle": Do,
  youtube: Mo
}, ee = [
  "arrow-left",
  "arrow-light-left",
  "arrow-light-right",
  "arrow-right",
  "chevron-left",
  "chevron-right",
  "diagnostics",
  "external-link",
  "file-download",
  "file",
  "list",
  "stock-down",
  "stock-equal",
  "stock-up",
  "loading"
];
export {
  ee as IconsRightToLeft,
  te as icons
};
